/**
 * @generated SignedSource<<87324b6fce65ae6aa14d8f3f4bf5b29f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ProfileRouteQuery$variables = {};
export type ProfileRouteQuery$data = {
  readonly viewer: {
    readonly id: string;
    readonly actualPersonId: string | null;
    readonly ticketingEmailSignature: string | null;
    readonly ticketingReplyToEmail: string | null;
  } | null;
};
export type ProfileRouteQuery = {
  variables: ProfileRouteQuery$variables;
  response: ProfileRouteQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Viewer",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actualPersonId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ticketingEmailSignature",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ticketingReplyToEmail",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileRouteQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProfileRouteQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "b038684977e906b1194e48c89cc35a41",
    "id": null,
    "metadata": {},
    "name": "ProfileRouteQuery",
    "operationKind": "query",
    "text": "query ProfileRouteQuery {\n  viewer {\n    id\n    actualPersonId\n    ticketingEmailSignature\n    ticketingReplyToEmail\n  }\n}\n"
  }
};
})();

(node as any).hash = "958ad74734232d93702d6b2e6828850b";

export default node;
